var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-right font-28" },
    [
      _vm.value || _vm.text
        ? _c("span", { class: [`font-${_vm.options.fontSize}`] }, [
            _vm._v(
              " " +
                _vm._s(_vm.text ? _vm.text : _vm.getShowFields(_vm.value)) +
                " "
            ),
          ])
        : _c("span", { staticClass: "cor-CC" }, [
            _vm._v(" " + _vm._s(_vm.placeholder) + " "),
          ]),
      _vm.isShowIcon
        ? _c("van-icon", { attrs: { name: "arrow", color: "#8c8c8c" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }